module.exports = __webpack_public_path__ + "static/media/kopa-logo.a6b2072c.svg";